import { useContext } from "react";
import { EpeAccessContext } from "../providers/EpeAccessProvider";

/** { access, loading, error, refresh } of the case page's EPE access (see EpeAccessProvider). */
export default function useEpeAccess() {
  const context = useContext(EpeAccessContext);
  if (context === undefined) {
    throw new Error("useEpeAccess must be used within an EpeAccessProvider");
  }
  return context;
}
